"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepositBankAccountConnectionOutcome = void 0;
// Narrower than EarlyBankConnectionVerificationOutcome on purpose: deposit sends business accounts to tryDifferentAccount
// instead of a separate businessAccountFailedAutomaticVerification outcome.
var DepositBankAccountConnectionOutcome;
(function (DepositBankAccountConnectionOutcome) {
    DepositBankAccountConnectionOutcome["verified"] = "verified";
    DepositBankAccountConnectionOutcome["documentUploadRequired"] = "documentUploadRequired";
    DepositBankAccountConnectionOutcome["tryDifferentAccount"] = "tryDifferentAccount";
    DepositBankAccountConnectionOutcome["pendingBankReview"] = "pendingBankReview";
})(DepositBankAccountConnectionOutcome || (exports.DepositBankAccountConnectionOutcome = DepositBankAccountConnectionOutcome = {}));
